








































































































import { QVueGlobals } from 'quasar';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import LayerSelector from '@/components/LayerSelector.vue';
import EsriPopup from '@/components/EsriPopup.vue';
import EsriSearch from '@/components/EsriSearch.vue';
import EsriPrint from '@/components/EsriPrint.vue';
import EsriSketch from '@/components/EsriSketch.vue';
import Map from '@/views/Map.vue';
import AddData from '@/components/AddData.vue';
import About from '@/components/About.vue';

@Component({
  components: {
      LayerSelector,
      EsriPopup,
      EsriSearch,
      EsriPrint,
      EsriSketch,
      Map,
      AddData,
      About,
    },
})

export default class LayoutPublic extends Vue {

  public widthThresholdValue: number = 475;

  get leftDrawerOpen() {
    return this.$store.state.leftDrawerOpen;
  }

  get rightDrawerOpen() {
    return this.$store.state.rightDrawerOpen;
  }

  get editLayer() {
    return this.$store.state.edit.layer;
  }

  get windowWidth() {
    return this.$store.state.windowWidth;
  }

  public mounted() {
    console.log('LayoutDefault: mounted()');
    this.$store.dispatch('updateWindowHeight', window.innerHeight);
    this.$store.dispatch('updateWindowWidth', window.innerWidth);

    window.addEventListener('resize', () => {
      this.$store.dispatch('updateWindowHeight', window.innerHeight);
      this.$store.dispatch('updateWindowWidth', window.innerWidth);
    } );
    return this.$store.state.isMobile = !this.$q.platform.is.desktop;
  }

  public onAbout() {
    this.$store.dispatch('aboutAction');
  }

  public drawerToggleLeft(content: string) {
    this.$store.dispatch('drawerToggleLeft', content);
  }

  public drawerToggleRight(content: string) {
    this.$store.dispatch('drawerToggleRight', content);
  }

  public sketchToggle() {
    this.$store.dispatch('sketchToggle');
  }
}
